import { env } from 'core/utils';

export default (name: string) => {
  if (env.POUCHDB_SOURCE === 'remote') {
    const url = `${env.POUCHDB_HOST}:${env.POUCHDB_PORT}/`;

    return `${url}${name}`;
  }

  return name;
};
